<ng-container *transloco="let t; read: 'findMyAgent'">
  <h2 class="text-heading-2">{{ t('results.paging.title') }}</h2>

  <div class="flex flex-col space-y-4 md:flex-row md:space-x-6 md:space-y-0">
    <button [rmaLoadingIndicator]="saving" (click)="save.emit()" type="button" mat-stroked-button color="primary" data-id="save">
      {{ t('persistence.save') }}
    </button>
    @if (canShowMore) {
      <button (click)="showMore.emit()" type="button" mat-stroked-button color="primary" data-id="show-more">
        {{ t('results.paging.more') }}
      </button>
    }
  </div>
</ng-container>
